import React, { memo } from 'react';
import { Tooltip } from 'react-tooltip'
interface PositionTy{
    x:number,
    y:number
}

type TooltipProps = {
    id: string; // Unique ID for the tooltip
    content: string | JSX.Element; // The content of the tooltip
    Children?: React.ReactNode; // The element that will trigger the tooltip
    place?: 'top' | 'right' | 'bottom' | 'left'; // Tooltip position
    effect?: 'float' | 'solid'; // Tooltip effect
    className?: string; // Optional custom class for the tooltip
    Side:"RSB" | "LSB";
    isClickable?:boolean;
    position?:PositionTy
    isOpen?:boolean
};

const ReactToolTip: React.FC<TooltipProps> = ({id,content,Children,place = 'top',effect = 'solid',className,Side,isClickable=false,position,isOpen=undefined}) => {
    return (
    <>
    {Children ? Children:<></>}
    <Tooltip isOpen={isOpen}   clickable={isClickable} style={{backgroundColor:`${Side==="RSB"?'rgb(255 255 255 / var(--tw-bg-opacity))':""}`,color:`${Side==="RSB"?'black':""}`,opacity:1,zIndex:9999}} position={position??undefined} id={id} place={place} className={`${className??"max-w-[10vw]"}`}>{content}</Tooltip>
    </>
);
};

export default memo(ReactToolTip)